var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`${_vm.el}__bar`,style:({ height: `${_vm.height}px` })},[_c('div',{class:`${_vm.el}__barProgress`,style:({ height: `${_vm.percent}%` })})])
}
var staticRenderFns = []

export { render, staticRenderFns }